import React, { useState, useEffect } from 'react';
import './css/CourseList.css';
import {
  ToggleButton,
  ButtonGroup,
  Popover,
  OverlayTrigger,
  Button,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { faCertificate } from '@fortawesome/free-solid-svg-icons';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import clientAxios from '../../../../clients/clientAxios';
import { notify } from 'react-notify-toast';
import Plans from '../modals/Plans';
import MigrationStudent from '../modals/MigrationStudent';
import { ShowPlanById } from '../modals/ShowPlanById';
const certificateBaseUrl = 'https://certs.rollingcodeschool.com';

function statusPillClass(statusKey) {
  switch (statusKey) {
    case 'up':
    case 'commissionChanged':
      return 'sd-pill sd-status-active';
    case 'done':
      return 'sd-pill sd-status-done';
    case 'down':
      return 'sd-pill sd-status-down';
    case 'posibleDown':
    case 'prepay':
      return 'sd-pill sd-status-warn';
    default:
      return 'sd-pill sd-status-muted';
  }
}

export default function CourseList({
  scholarship,
  classroom,
  isActive,
  course,
  price,
  certificate,
  classroomActive,
  fullClassRoom,
  studentId,
  certificatesFromService,
  student,
  getStudentData,
  hideLoadingLayout,
  onCollapsePanel = () => {},
}) {
  const [classRoomActiveStatusState, setClassRoomActiveStatusState] = useState(
    classroomActive || []
  );
  const [fullPlanInfo, setFullPlanInfo] = useState({
    planId: '',
    classroom: '',
    classroomId: '',
  });
  const [popOverState, setPopOvers] = useState(0);
  const [currentClassroomId, setCurrentClassroomId] = useState('');
  const [state, setState] = useState('');
  const [indexState, setIndexState] = useState('');
  const loadingLayoutRefreshTimeout = 1000;
  const [show, setShow] = useState(false);
  const [classroomIndex, setClassroomIndex] = useState(null);
  const handlePlansModalClose = () => setShow(false);
  const handlePlansModalShow = () => setShow(true);
  const [showMigrationModal, setShowMigrationModal] = useState(false);
  const [selectedClassroom, setSelectedClassroom] = useState(null);

  useEffect(() => {
    setClassRoomActiveStatusState(classroomActive || []);
    //eslint-disable-next-line
  }, [classroomActive]);

  const setActiveStatus = async (classroomId, status) => {
    hideLoadingLayout(false);
    try {
      if (popOverState === 2 || popOverState === 1 || popOverState === 0) {
        const { data } = await clientAxios.patch('/students', {
          studentId,
          classroomId,
          status,
          email: student?.email,
        });

        if (data.success) {
          notify.show(
            'Se ha actualizado el estado del comision en Rolling Universe',
            'success'
          );
        } else {
          notify.show(data.message, 'error');
        }
        getStudentData();
        setTimeout(() => {
          hideLoadingLayout(true);
        }, loadingLayoutRefreshTimeout);
      }
    } catch (err) {
      getStudentData();
      hideLoadingLayout(true);
      notify.show(
        'No se pudo actualizar el testado de la comision, intenta mas tarde por favor',
        'error'
      );
    }
  };
  const translateIsActive = (currentIsActive) => {
    switch (currentIsActive) {
      case 'up':
        return {
          className: 'text-dark',
          text: 'Activo',
        };
      case 'done':
        return {
          className: 'text-success',
          text: 'Curso finalizado',
        };
      case 'posibleDown':
        return {
          className: 'text-darkYell',
          text: 'Posible baja',
        };
      case 'prepay':
        return {
          className: 'text-darkYell',
          text: 'Curso señado',
        };
      case 'down':
        return {
          className: 'text-danger',
          text: 'Baja',
        };
      case 'commissionChanged':
        return {
          className: 'text-dark',
          text: 'Activo (Cambió comisión)',
        };
      default:
        return {
          className: 'text-muted',
          text: 'No especificado',
        };
    }
  };

  const getPropertyFromArrayOfActiveOrPrice = (
    currentClassRoom,
    arrayToGetElement
  ) => {
    if (student.classroom?.length > 0) {
      const indexStudent = student.classroom.findIndex(
        (element) => element === currentClassRoom.classroom
      );
      if (indexStudent !== -1) {
        return arrayToGetElement ? arrayToGetElement[indexStudent] : '';
      }
    }
    return '';
  };

  const getCertUrl = (certItem) => {
    if (certItem?.filename?.includes('.png')) {
      return `${certificateBaseUrl}/${certItem?.filename}`;
    }
    return `${certificateBaseUrl}/${certItem?.filename}_1.png`;
  };

  const getScholarshipStatus = (classroomName) => {
    if (student?.classroom?.length <= 0) {
      return false;
    }
    const scholarshipIndex = student?.classroom?.findIndex(
      (element) => element === classroomName
    );
    if (scholarshipIndex === -1) {
      return false;
    }
    return (
      scholarshipIndex <= student?.scholarship.length &&
      student?.scholarship[scholarshipIndex]
    );
  };

  const hasNoPlan = (classroomId, index, classroomName, currentClassroom) => {
    if (!student?.plan) {
      return (
        <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
          <span className="sd-pill sd-status-down">Sin plan de pago</span>
          <Button
            size="sm"
            className="sd-btn"
            onClick={() => {
              handlePlansModalShow();
              setFullPlanInfo({
                classroomId,
                classroom: classroomName,
                planId: '',
              });
              setClassroomIndex(index);
            }}
          >
            Agregar plan
          </Button>
        </div>
      );
    }
    const validPlan = student?.plan?.find(
      (plan) => plan?.classroomId === classroomId
    );
    if (validPlan) {
      return (
        <div className="d-flex align-items-center flex-wrap" style={{ gap: 4 }}>
          <ShowPlanById
            id={validPlan.planId}
            student={student}
            indexCommission={index}
            renderButton={(handleClick) => (
              <Button
                size="sm"
                variant="outline-info"
                className="ml-1"
                onClick={handleClick}
                title="Ver plan"
              >
                <FontAwesomeIcon icon={faClipboardList} />
              </Button>
            )}
          />
          <Button
            size="sm"
            variant="outline-dark"
            className="ml-1"
            onClick={() => {
              setSelectedClassroom(currentClassroom);
              setShowMigrationModal(true);
            }}
            disabled={
              translateIsActive(
                getPropertyFromArrayOfActiveOrPrice(currentClassroom, isActive)
              ).text === 'Curso finalizado'
            }
            title="Migrar alumno"
          >
            <FontAwesomeIcon icon={faSync} />
          </Button>
        </div>
      );
    }
    return (
      <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
        <span className="sd-pill sd-status-down">Sin plan de pago</span>
        <Button
          size="sm"
          className="sd-btn"
          onClick={() => {
            handlePlansModalShow();
            setFullPlanInfo({
              classroomId,
              classroom: classroomName,
              planId: '',
            });
            setClassroomIndex(index);
          }}
        >
          Agregar plan
        </Button>
      </div>
    );
  };

  const handleFunction = (opcion) => {
    setPopOvers(opcion);
  };

  useEffect(() => {
    if (popOverState !== 0) {
      setActiveStatus(currentClassroomId, state, indexState);
    }
  }, [handleFunction]);

  const popoverTop = (
    <Popover id="popover-positioned-top">
      <button onClick={() => handleFunction(2)} className="btn w-100">
        Suspender en Universe
      </button>
    </Popover>
  );

  const enrollmentCount = Array.isArray(fullClassRoom)
    ? fullClassRoom.length
    : 0;

  return (
    <>
      <div className="sd-card w-100">
        <div className="sd-panel-head">
          <div>
            <h3 className="sd-section-title">Cursos inscriptos</h3>
            <p className="sd-section-sub">
              {enrollmentCount > 0
                ? `${enrollmentCount} ${
                    enrollmentCount === 1 ? 'comisión' : 'comisiones'
                  } · Estado Universe y plan de pago`
                : 'Sin comisiones asignadas'}
            </p>
          </div>
          <Button
            variant="outline-secondary"
            size="sm"
            className="sd-hide-btn"
            onClick={onCollapsePanel}
            title="Ocultar panel"
          >
            <FontAwesomeIcon icon={faEyeSlash} />
          </Button>
        </div>
        <div className="mt-3">
          {typeof course === 'object' && typeof classroom === 'object' ? (
            fullClassRoom.map((currentClassroom, index) => {
              const statusKey = getPropertyFromArrayOfActiveOrPrice(
                currentClassroom,
                isActive
              );
              const statusInfo = translateIsActive(statusKey);
              const isScholarship =
                scholarship &&
                scholarship.length > 0 &&
                getScholarshipStatus(currentClassroom?.classroom);
              return (
                <div key={index} className="sd-enrollment">
                  <div className="sd-enrollment-head">
                    <div style={{ minWidth: 0 }}>
                      <div className="sd-enrollment-index">
                        Comisión 0{index + 1}
                      </div>
                      <div className="sd-enrollment-course">
                        {course[index] === null ? (
                          <i style={{ fontWeight: 500, fontSize: 13 }}>
                            Esta comisión no tiene un curso asignado
                          </i>
                        ) : course[index] === undefined ? (
                          <i style={{ fontWeight: 500, fontSize: 13 }}>
                            Verificar que el curso esté configurado correctamente
                            en la comisión
                          </i>
                        ) : (
                          course[index]
                        )}
                      </div>
                    </div>
                    <span className={statusPillClass(statusKey)}>
                      {statusInfo.text}
                    </span>
                  </div>
                  <div className="sd-field">
                    <span className="sd-label">Comisión</span>
                    <span className="sd-value">
                      {currentClassroom.classroom}
                    </span>
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-between flex-wrap mt-2"
                    style={{ gap: 8 }}
                  >
                    <div className="sd-universe-toggle">
                      <ButtonGroup className="mb-2">
                        {classRoomActiveStatusState?.find(
                          (element) => element?._id === currentClassroom._id
                        ) && (
                          <ToggleButton
                            key={`radioActive-${index}`}
                            id={index}
                            type="radio"
                            variant="outline-success"
                            name={`radioActive-${index}`}
                            value="active"
                            checked={classRoomActiveStatusState?.find(
                              (element) =>
                                element?._id === currentClassroom._id &&
                                element.status === 'active'
                            )}
                            onClick={() => {
                              setActiveStatus(
                                currentClassroom._id,
                                'active',
                                index
                              );
                            }}
                          >
                            Activo
                          </ToggleButton>
                        )}
                        <OverlayTrigger
                          trigger="click"
                          placement="top"
                          overlay={popoverTop}
                        >
                          <ToggleButton
                            key={`radioSuspended-${index}`}
                            id={`radio-${index}`}
                            type="radio"
                            variant="outline-danger"
                            name={`radioSuspended-${index}`}
                            value="suspended"
                            checked={classRoomActiveStatusState?.find(
                              (element) =>
                                element?._id === currentClassroom._id &&
                                element.status === 'suspended'
                            )}
                            style={{ position: 'relative' }}
                          >
                            Suspendido
                            <Button
                              className="buttonHidden"
                              key={index}
                              onClick={() => {
                                setCurrentClassroomId(currentClassroom._id);
                                setState('suspended');
                                setIndexState(index);
                              }}
                            ></Button>
                          </ToggleButton>
                        </OverlayTrigger>
                        <br />
                      </ButtonGroup>
                    </div>
                    {hasNoPlan(
                      currentClassroom?._id,
                      index,
                      currentClassroom?.classroom,
                      currentClassroom
                    )}
                  </div>
                  {isScholarship ? (
                    <div className="mt-2">
                      <span className="sd-pill sd-pill-info">Becado</span>
                    </div>
                  ) : null}
                </div>
              );
            })
          ) : (
            <div className="sd-enrollment">
              <div className="sd-enrollment-course">{course}</div>
              <div className="sd-field">
                <span className="sd-label">Comisión</span>
                <span className="sd-value">{classroom}</span>
              </div>
              <div className="sd-field">
                <span className="sd-label">Precio</span>
                <span className="sd-value">${price}</span>
              </div>
              <div className="sd-field">
                <span className="sd-label">Estado</span>
                <span className={statusPillClass(isActive || '')}>
                  {translateIsActive(isActive || '').text}
                </span>
              </div>
              {scholarship && scholarship.length > 0 && scholarship[0] && (
                <div className="mt-2">
                  <span className="sd-pill sd-pill-info">Becado</span>
                </div>
              )}
            </div>
          )}
          <div className="mt-3">
            <div className="sd-eyebrow">Certificados</div>
            {certificate && certificate.loading && (
              <div className="sd-value-muted" style={{ fontSize: 13 }}>
                Cargando certificados…
              </div>
            )}
            {certificate &&
              !certificate.loading &&
              certificate.items.length === 0 && (
                <div className="sd-value-muted" style={{ fontSize: 13 }}>
                  Sin certificados emitidos
                </div>
              )}
            {certificate && certificate.items.length > 0 && (
              <ul className="sd-cert-list">
                {certificate.items.map((certItem, certIndex) => (
                  <li
                    key={certItem?.filename || certIndex}
                    className="sd-cert-item"
                  >
                    {certItem?.filename && (
                      <>
                        <a
                          href={getCertUrl(certItem)}
                          target="_blank"
                          rel="noreferrer"
                          className="sd-cert-icon"
                          title="Ver certificado"
                        >
                          <FontAwesomeIcon icon={faCertificate} size="sm" />
                        </a>
                        <span>{certItem?.courseName}</span>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
      <Plans
        show={show}
        studentId={studentId}
        student={student}
        setFullPlanInfo={setFullPlanInfo}
        fullPlanInfo={fullPlanInfo}
        classroomIndex={classroomIndex}
        getStudentData={getStudentData}
        handlePlansModalClose={handlePlansModalClose}
      />
      <MigrationStudent
        showMigrationModal={showMigrationModal}
        onClose={(refresh) => {
          setShowMigrationModal(false);
          if (refresh) getStudentData();
        }}
        currentClassroom={selectedClassroom}
        studentId={studentId}
        studentName={student?.name || student?.fullName || 'Alumno'}
      />
    </>
  );
}
